import React                        from 'react';
import {
  DataTable,
  SearchPagination,
}                                   from '@components/index';
import { TDataTableRow }            from '@typings/components';
import { VIN_DECODE_TABLE_HEADERS } from '../utils/tableHeaders';

interface IProps {
  tableRows                  : TDataTableRow[];
  rowsPerPage                : number;
  currentPage                : number;
  handleChangePage           : (page: number) => void;
  totalVinDecodeHistoryCount : number;
  isLoading                  : boolean;
}

export const VinDecodeHistoryTable: React.FC<IProps> = ({
  tableRows,
  rowsPerPage,
  currentPage,
  handleChangePage,
  totalVinDecodeHistoryCount,
  isLoading,
}) => (
  <>
    <DataTable
      rows     = {tableRows}
      headers  = {VIN_DECODE_TABLE_HEADERS}
      maxwidth = "1680px"
      loading  = {isLoading}
    />

    {!!totalVinDecodeHistoryCount && (
      <SearchPagination
        currentPage      = {currentPage}
        rowsPerPage      = {rowsPerPage}
        totalItems       = {totalVinDecodeHistoryCount}
        handleChangePage = {handleChangePage}
        maxWidth         = "1680px"
      />
    )}
  </>
);
